import React from "react";

/** Espelha BordeiroService.ESTOQUE_LIMITE_AUTO_ABATE: acima disso os cards de pedido voltam ao bordeiro. */
export const LIMITE_ESTOQUE = 0.8;

export function pctConsumo(consumido: number, planejado: number): number {
  return planejado > 0 ? consumido / planejado : 0;
}

function cores(pct: number): { texto: string; barra: string } {
  if (pct >= 1) return { texto: "text-red-600", barra: "bg-red-500" };
  if (pct >= LIMITE_ESTOQUE)
    return { texto: "text-amber-600", barra: "bg-amber-500" };
  return { texto: "text-emerald-700", barra: "bg-emerald-500" };
}

type Props = { consumido: number; planejado: number };

/**
 * % do estoque de UM tamanho já consumido. A liberação dos cards de pedido é
 * por borda+tamanho, então o consumo nunca é somado entre tamanhos.
 */
const UsoTamanho: React.FC<Props> = ({ consumido, planejado }) => {
  const pct = pctConsumo(consumido, planejado);
  const { texto, barra } = cores(pct);
  return (
    <div className="flex items-center justify-end gap-1.5">
      <div
        className="relative h-1.5 w-12 overflow-hidden rounded-full bg-neutral-100"
        title={`${Math.round(LIMITE_ESTOQUE * 100)}%: cards de pedido voltam ao bordeiro`}
      >
        <div
          className={`h-full rounded-full ${barra}`}
          style={{ width: `${Math.min(pct, 1) * 100}%` }}
        />
        <div
          className="absolute inset-y-0 w-px bg-neutral-500/70"
          style={{ left: `${LIMITE_ESTOQUE * 100}%` }}
        />
      </div>
      <span
        className={`w-9 text-right text-xs font-semibold tabular-nums ${texto}`}
      >
        {Math.round(pct * 100)}%
      </span>
    </div>
  );
};

export default UsoTamanho;
